module.exports = __webpack_public_path__ + "static/shedrach-4f0ab5e4867be0ff437702c7870d54c8.png";